import { ApolloError } from 'apollo-client-preset';
import { SubmissionError } from 'redux-form';

import { ValidationError } from '../../GraphQL';
import { FormErrors } from '../../components/Form/formErrors.locale';

export const formErrorHandler = (error: ApolloError | ValidationError[]) => {
  const formErrors = (errors: { [key: string]: string }) =>
    Promise.reject(new SubmissionError(errors)).then(finalErrors => finalErrors);

  if (error instanceof ApolloError) {
    const generalErrorKey = '_error';
    if (error.networkError) {
      return formErrors({
        [generalErrorKey]: FormErrors.network,
      });
    }

    return formErrors({
      [generalErrorKey]: FormErrors.general,
    });
  }

  type Errors = { [key: string]: Errors | string };

  const getErrors = (validationErrors: ValidationError[]) => {
    let errors: Errors = {};

    validationErrors.forEach(validationError => {
      const nestError = (object: Errors = {}, path: string[]): Errors | string => {
        if (path.length === 0) {
          return validationError.message;
        }

        const key = path.shift() as string;
        return { ...object, [key]: nestError(object[key] as Errors, path) };
      };

      errors = nestError(errors, validationError.path) as Errors;
    });

    return errors;
  };

  return formErrors(getErrors(error) as { [key: string]: string });
};



// WEBPACK FOOTER //
// /www/client/src/containers/Validator/formErrorHandler.ts